import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { notNullsy } from '~/_shared/utils/typeGuards';
import {
  BoundaryEditAction, BoundaryEditManualMethod,
} from '~/boundary/editMode/boundaryEditModal/boundaryEditModal.helpers';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import { boundaryTerritoryGroupPatchSettings } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.actionCreators';
import { useGetBoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { boundaryDrawAdvancedEditOpenModal } from '~/store/frontendState/mapTools/boundary/boundaryDraw/boundaryDraw.actionCreators';
import {
  boundarySelectEditCloseModal,
  boundarySelectEditCustomBoundaryOpenModal,
} from '~/store/frontendState/mapTools/boundary/boundarySelect/boundarySelect.actionCreators';
import type { BoundarySelectState } from '~/store/frontendState/mapTools/boundary/boundarySelect/boundarySelect.state';

export const useBoundaryEditAnother = () => {
  const dispatch = useDispatch();
  const { getBoundaryTerritoryGroupById } = useGetBoundaryTerritoryGroup();

  const onBoundaryEditSubmit = useCallback(({ editAnother, editedBoundaryTerritoryGroupId, method, selectMethodBoundaryGroupId, onEditAnotherSubmit, onEditAnotherClose }:
  {
    editAnother: boolean;
    editedBoundaryTerritoryGroupId: BoundaryTerritoryGroupId;
    method: BoundaryEditManualMethod;
    selectMethodBoundaryGroupId?: BoundaryGroupId;
    onEditAnotherSubmit: (selectState: BoundarySelectState) => void;
    onEditAnotherClose: () => void;
  }) => {
    if (method === BoundaryEditManualMethod.Selection && notNullsy(selectMethodBoundaryGroupId)) {
      dispatch(boundaryTerritoryGroupPatchSettings({
        boundaryTerritoryGroupId: editedBoundaryTerritoryGroupId,
        patcher: (currentSettings) => ({
          ...currentSettings,
          selectionEditPreferredBoundaryGroup: {
            id: selectMethodBoundaryGroupId,
          },
        }),
      }));

      if (editAnother) {
        dispatch(boundarySelectEditCustomBoundaryOpenModal({
          boundaryTerritoryGroupId: editedBoundaryTerritoryGroupId,
          selectBoundaryGroupId: selectMethodBoundaryGroupId,
          actionType: BoundaryEditAction.EditBoundaries,
          onSubmit: onEditAnotherSubmit,
          onClose: onEditAnotherClose,
        }));
      }
    }
    else if (method === BoundaryEditManualMethod.Draw) {
      if (editAnother) {
        const btg = getBoundaryTerritoryGroupById(editedBoundaryTerritoryGroupId);
        if (btg) {
          dispatch(boundaryDrawAdvancedEditOpenModal({
            boundaryGroupId: btg.boundaryGroupId,
            boundaryTerritoryGroupId: editedBoundaryTerritoryGroupId,
            action: BoundaryEditAction.EditBoundaries,
          }));
        }
      }
    }
    else {
      dispatch(boundarySelectEditCloseModal());
    }
  }, [dispatch, getBoundaryTerritoryGroupById]);

  return {
    onBoundaryEditSubmit,
  };
};
